module.exports = __webpack_public_path__ + "img/Spartak-Moscow.7b4a852b.png";